module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('div', {
    staticClass: "titlePage"
  }, [_c('h2', {
    staticClass: "titlePageTitle"
  }, [_vm._v("GOD’S"), _c('br'), _vm._v("SECRETARIES")]), _vm._v(" "), _c('h3', {
    staticClass: "titlePageSubtitle"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Making of the King James Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "titlePageAuthor"
  }, [_vm._v("ADAM NICOLSON")]), _vm._v(" "), _c('p', {
    staticClass: "titlePagePublisher"
  }, [_c('img', {
    attrs: {
      "alt": "logo",
      "src": "logo.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25fbc2ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/godssecretaries.vue
// module id = 60
// module chunks = 0